import { CerFormAdapter } from "@form/cer-form-adapter";
import { CerFormViewSet } from "@form/cer-form-view-set";
import { CerFormView } from "@form/cer-form-view";
import { UiCommandRenderCell } from "@data/cer-data-types";

export class DataTagTypeForm extends CerFormAdapter {

  public override viewSetInit(viewSet: CerFormViewSet): void {

    const view = this.viewGet();
    viewSet.viewAdd(view);
  }

  private viewGet(): CerFormView {
    const view = new CerFormView();

    view.viewMetadata = {
      name: 'kategori-typer', dataApiName: 'DataTagType', text: 'Kategori typer', textSingular: 'Kategori type',
      primaryKey: 'id', baseFields: ['id', 'history']
    };

    view.fieldMetadata = [
      { name: 'name', text: 'Kategori navn',required: true },
      { name: 'shortName', text: 'Kategori forkortelse' },
      { name: 'color', text: 'Farve', format: 'IntegerColor', width: '40px' },
      { name: 'dataTable', fieldType: 'dataTable' }
    ];

    return view;
  }
}
